import {useNavigate} from 'react-router-dom'
import { m } from 'framer-motion';
import { Helmet } from 'react-helmet-async';
// @mui
import { Button, Typography } from '@mui/material';
// components
import { MotionContainer, varBounce } from '../components/animate';

// ----------------------------------------------------------------------

export default function NetowrkError() {
  const navigate = useNavigate()

  return (
    <>
      <Helmet>
        <title>Ошибка сети</title>
      </Helmet>

      <MotionContainer>
        <m.div variants={varBounce().in}>
          <Typography variant="h3" paragraph>
            Ошибка сети
          </Typography>
        </m.div>

        <m.div variants={varBounce().in}>
          <Typography sx={{ color: 'text.secondary', my: 2, }}>
            Пожалуйста, проверьте ваше подключение к сети.
          </Typography>
        </m.div>

    
        <Button onClick={()=> navigate(-1)} size="large" variant="contained" sx={{textTransform: "inherit"}}>
          Назад
        </Button>
      </MotionContainer>
    </>
  );
}
